import { createApp } from 'vue';
import App from './App.vue';
import i18n from './plugins/i18n';
import store from './store';
import router from './router';

createApp(App)
  .use(store)
  .use(i18n)
  .use(router)
  .mount('#app');
